<template>
  <div class="communicationList">
    <table-info
      :tableInfo="communicationTable"
      :total="total"
      :queryInfo="queryInfo"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    >
      <template #default="slotProps">
        <div class="talentProgress">
          人才进度：
          <dic-select
            class="mini-select"
            :code.sync="slotProps.childInfo.talentProgress"
            type-code="012"
            :extraInfo="{
              id: slotProps.childInfo.id,
              talentProgress: slotProps.childInfo.talentProgress
            }"
            placeholder="请选择"
            @changeVal="changeTalentProgress"
          />
        </div>
      </template>
      <template #controlBtn="slotProps">
        <div class="btn-control">
          <icon-and-button
            title="编辑报告"
            icon="icon-jr-icon-note"
            :extraInfo="{ personCode: slotProps.childInfo.personCode }"
            @handleControl="handleControl"
          />
          <icon-and-button
            title="面试邀约"
            icon="icon-jr-icon-calendar"
            :extraInfo="{ personCode: slotProps.childInfo.personCode }"
            @handleControl="handleControl"
          />
          <icon-and-button
            title="候选人记录"
            icon="icon-jr-icon-pen"
            :extraInfo="{
              personCode: slotProps.childInfo.personCode,
              projectId: slotProps.childInfo.projectId
            }"
            @handleControl="handleControl"
          />
          <icon-and-button
            title="查看详情"
            icon=""
            :buttonStyle="{ color: '#17757A' }"
            :extraInfo="{ personCode: slotProps.childInfo.personCode }"
            @handleControl="handleControl"
          />
        </div>
      </template>
    </table-info>
  </div>
</template>

<script>
import { getCommunication, updateTalentProgress } from '@/api/projectCenter'
import IconAndButton from '@/components/IconAndButton.vue'
import tableInfo from '../cpns/tableInfo.vue'
import DicSelect from '@/components/DicSelect.vue'

export default {
  props: {
    id: {
      type: Number
    },
    tabName: {
      type: String
    },
    searchInfo: {
      type: Object
    },
    positionType: {
      type: String
    }
  },

  components: {
    IconAndButton,
    tableInfo,
    DicSelect
  },

  data() {
    return {
      queryInfo: {
        baseParam: {
          pageNum: 0, //页数
          pageSize: 30 //大小
        },
        id: ''
      },
      communicationTable: [], // 列表数据
      total: 0, // 条数
      dialogVisible: false // 弹窗状态
    }
  },

  watch: {
    tabName: {
      handler: function (newVal) {
        if (newVal === 'third') {
          if (Object.keys(this.$store.state.projectCenter.communicateQueryInfo).length) {
            Object.keys(this.$store.state.projectCenter.communicateQueryInfo).forEach((item) => {
              this.queryInfo[item] = this.$store.state.projectCenter.communicateQueryInfo[item]
            })
          }
          this.search()
        }
      },
      immediate: true
    }
  },

  methods: {
    async search() {
      this.queryInfo.id = this.id
      const { data: res } = await getCommunication(this.queryInfo)
      if (res.resultCode === 200) {
        this.communicationTable = res.data.list
        this.communicationTable.forEach((item) => {
          if (!item.talentProgress) {
            item.talentProgress = ''
          }
        })
        this.total = res.data.total
      }
    },
    handleCurrentChange(newPage) {
      this.queryInfo.baseParam.pageNum = newPage
      this.search()
    },
    handleSizeChange(newSize) {
      this.queryInfo.baseParam.pageSize = newSize
      this.search()
    },
    handleControl(val, info) {
      if (val === '编辑报告') {
        this.$router.push({
          path: '/businessManagement/projectCenter/candidate/editReport',
          query: {
            ...info,
            projectId: this.id,
            chidrenQueryInfo: JSON.stringify(this.queryInfo), // 本页面的查询条件
            tabName: this.tabName,
            positionType: this.positionType,
            searchInfo: JSON.stringify(this.searchInfo) // 项目中心的查询条件
          }
        })
      } else if (val === '候选人记录') {
        this.$router.push({
          path: '/businessManagement/projectCenter/candidate/records',
          query: {
            ...info
          }
        })
      } else if (val === '查看详情') {
        this.$router.push({
          name: 'TalentMessageView',
          query: {
            id: info.personCode,
            clientType: 1,
            chidrenQueryInfo: JSON.stringify(this.queryInfo), // 本页面的查询条件
            projectId: this.id,
            tabName: this.tabName,
            positionType: this.positionType,
            searchInfo: JSON.stringify(this.searchInfo) // 项目中心的查询条件
          }
        })
      }
    },
    // 修改人才进度
    async changeTalentProgress(val, info) {
      info.talentProgress = val
      const { data: res } = await updateTalentProgress(info)
      if (res.resultCode === 200) {
        this.$message.success('修改成功')
        this.search()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.communicationList {
  .talentProgress {
    font-size: 14px;
    display: flex;
    align-items: center;
    margin-bottom: 8px;
  }
}
</style>
